export const GLOBE_RADIUS = 2;
export const FILL_RADIUS = GLOBE_RADIUS * 1.005;
export const PIN_RADIUS = GLOBE_RADIUS * 1.006;

export function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export function easeOutQuart(t) {
    return 1 - Math.pow(1 - t, 4);
}

export function latLngToSphere(lat, lng, radius) {
    const phi = (90 - lat) * (Math.PI / 180);
    const theta = (lng + 180) * (Math.PI / 180);
    return [
        -radius * Math.sin(phi) * Math.cos(theta),
        radius * Math.cos(phi),
        radius * Math.sin(phi) * Math.sin(theta),
    ];
}

const FLAT_SCALE_X = 2.0;
const FLAT_SCALE_Y = 2.0;

export function morphedXYZ(lat, lng, radius, t) {
    const et = easeInOutCubic(t);
    const sp = latLngToSphere(lat, lng, radius);
    const fpX = (lng / 180) * radius * FLAT_SCALE_X;
    const fpY = (lat / 90) * radius * FLAT_SCALE_Y * 0.5;
    const zFade = Math.pow(1 - et, 2);
    return [
        sp[0] + (fpX - sp[0]) * et,
        sp[1] + (fpY - sp[1]) * et,
        sp[2] * zFade,
    ];
}
